import {
  getFloat,
} from "@surya-digital/leo-ts-types";


export namespace QuartileRange {
  export interface BetweenValuesDTO {
    case: string;
    startValue: number;
    endValue: number;
  }
  
  export class BetweenValues {
    readonly isQuartileRangeBetweenValues: boolean = true;
  
    readonly startValue: number;
    readonly endValue: number;
  
  
    constructor(
    startValue: number, 
    endValue: number
    ) {
      this.startValue = startValue;
      this.endValue = endValue;
    }
  
    static fromDTO(dto: BetweenValuesDTO): BetweenValues {
      const startValue = getFloat(dto, "startValue", InvalidQuartileRangeBetweenValuesStartValueError);
      const endValue = getFloat(dto, "endValue", InvalidQuartileRangeBetweenValuesEndValueError);
      return new BetweenValues(
        startValue,
        endValue
      );
    }
  
    toDTO(): BetweenValuesDTO {
      const dto: BetweenValuesDTO = {
        case: "BETWEEN_VALUES",
          startValue: this.startValue,
          endValue: this.endValue
      };
      return dto;
    }
    }
  
  BetweenValues.prototype.toString = function toString(): string {
    return `QuartileRange.BETWEEN_VALUES(startValue='${this.startValue}',endValue='${this.endValue}')`;
  };
  
  export interface LesserThanDTO {
    case: string;
    lesserThanValue: number;
  }
  
  export class LesserThan {
    readonly isQuartileRangeLesserThan: boolean = true;
  
    readonly lesserThanValue: number;
  
  
    constructor(
    lesserThanValue: number
    ) {
      this.lesserThanValue = lesserThanValue;
    }
  
    static fromDTO(dto: LesserThanDTO): LesserThan {
      const lesserThanValue = getFloat(dto, "lesserThanValue", InvalidQuartileRangeLesserThanLesserThanValueError);
      return new LesserThan(
        lesserThanValue
      );
    }
  
    toDTO(): LesserThanDTO {
      const dto: LesserThanDTO = {
        case: "LESSER_THAN",
          lesserThanValue: this.lesserThanValue
      };
      return dto;
    }
    }
  
  LesserThan.prototype.toString = function toString(): string {
    return `QuartileRange.LESSER_THAN(lesserThanValue='${this.lesserThanValue}')`;
  };
  
  export interface GreaterThanDTO {
    case: string;
    greaterThanValue: number;
  }
  
  export class GreaterThan {
    readonly isQuartileRangeGreaterThan: boolean = true;
  
    readonly greaterThanValue: number;
  
  
    constructor(
    greaterThanValue: number
    ) {
      this.greaterThanValue = greaterThanValue;
    }
  
    static fromDTO(dto: GreaterThanDTO): GreaterThan {
      const greaterThanValue = getFloat(dto, "greaterThanValue", InvalidQuartileRangeGreaterThanGreaterThanValueError);
      return new GreaterThan(
        greaterThanValue
      );
    }
  
    toDTO(): GreaterThanDTO {
      const dto: GreaterThanDTO = {
        case: "GREATER_THAN",
          greaterThanValue: this.greaterThanValue
      };
      return dto;
    }
    }
  
  GreaterThan.prototype.toString = function toString(): string {
    return `QuartileRange.GREATER_THAN(greaterThanValue='${this.greaterThanValue}')`;
  };
  

  export type QuartileRange = BetweenValues | LesserThan | GreaterThan;

  export type QuartileRangeDTO = BetweenValuesDTO | LesserThanDTO | GreaterThanDTO;

  export const fromDTO = (dto: QuartileRangeDTO): QuartileRange => {
    switch (dto.case) {
      case "BETWEEN_VALUES":
          return BetweenValues.fromDTO(dto as BetweenValuesDTO);
      case "LESSER_THAN":
          return LesserThan.fromDTO(dto as LesserThanDTO);
      case "GREATER_THAN":
          return GreaterThan.fromDTO(dto as GreaterThanDTO);
      default:
        throw new InvalidQuartileRangeError(
            `Case ${dto.case} is not valid case of QuartileRange.`
        );
    }
  };
}

export class InvalidQuartileRangeError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileRangeError";
  }
}
export class InvalidQuartileRangeBetweenValuesError extends InvalidQuartileRangeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileRangeBetweenValuesError";
  }
}

export class InvalidQuartileRangeBetweenValuesStartValueError extends InvalidQuartileRangeBetweenValuesError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileRangeBetweenValuesStartValueError";
  }
}

export class InvalidQuartileRangeBetweenValuesEndValueError extends InvalidQuartileRangeBetweenValuesError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileRangeBetweenValuesEndValueError";
  }
}

export class InvalidQuartileRangeLesserThanError extends InvalidQuartileRangeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileRangeLesserThanError";
  }
}

export class InvalidQuartileRangeLesserThanLesserThanValueError extends InvalidQuartileRangeLesserThanError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileRangeLesserThanLesserThanValueError";
  }
}

export class InvalidQuartileRangeGreaterThanError extends InvalidQuartileRangeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileRangeGreaterThanError";
  }
}

export class InvalidQuartileRangeGreaterThanGreaterThanValueError extends InvalidQuartileRangeGreaterThanError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileRangeGreaterThanGreaterThanValueError";
  }
}
